import { ApiWebsocketProvider as SharedApiWebsocketProvider } from '@zealot/ui/lib/ws/ApiWebsocketProvider';
import type { ReactNode } from 'react';
import { useAuth } from '@/pages/AuthContext';
import { NEW_API_URL } from '@/utils/api';

type ApiWebsocketProviderProps = {
  children: ReactNode;
};

export const ApiWebsocketProvider = ({ children }: ApiWebsocketProviderProps) => {
  const { fetchToken } = useAuth();
  return (
    <SharedApiWebsocketProvider getToken={fetchToken} baseUrl={NEW_API_URL}>
      {children}
    </SharedApiWebsocketProvider>
  );
};
